"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetRefAuditsResponse = exports.GetRefsResponse = exports.GetRefResponse = void 0;
class GetRefResponse {
}
exports.GetRefResponse = GetRefResponse;
class GetRefsResponse {
}
exports.GetRefsResponse = GetRefsResponse;
class GetRefAuditsResponse {
}
exports.GetRefAuditsResponse = GetRefAuditsResponse;
//# sourceMappingURL=resource.js.map